<template lang="pug">
v-layout
  v-dialog(v-model="openPopup" persistent width="300" )
    v-card(style="display: flex;flex-direction: column;justify-content: center; border-radius:5px")
      v-card-text.pt-3.pb-1
        v-flex(style="text-align:center")
          span {{ textIconMisDatos2 }}
      v-card-actions.py-3
        v-flex(style="text-align:center")
          v-btn(@click="openPopup=false" color="#EA0D90" style="width:10rem;height:2.7rem;border-radius:5px")
            span(style="color:#fff;text-transform:Capitalize" ) ok
  v-flex(style="max-width:2.3em;display: flex;align-items: center;")
    img(style="height: 14px;" :src="iconMisDatos1")
  v-flex(style="margin-right:5px;max-width: fit-content;display: flex;")
    span(style="font-size: 14px;") {{textMisDatos1}}
  v-flex(style="margin-right:10px;max-width: fit-content;display: flex;align-items: center;")
    v-tooltip(
      v-if="$vuetify.breakpoint.width >= 1024"
      bottom
      max-width="180"
      )
      template(v-slot:activator="{on}")
        img(
        v-on="on"
        :src="iconMisDatos2"
        style="height: 16px"
        )
      span(style="color: #ffffff") {{ textIconMisDatos2 }}
    img(
      v-else
      @click="openPopup=true"
      :src="iconMisDatos2"
      style="height:16px")
  v-flex(style="display: flex;justify-content: right;")
    span(:style="`font-size: 14px;text-transform: ${ textTransform || 'capitalize'} !important;`") {{textMisDatos2}}
</template>

<script>
export default {
  props: [
    'textMisDatos1',
    'textMisDatos2',
    'iconMisDatos1',
    'iconMisDatos2',
    'textIconMisDatos2',
    'textTransform'
  ],
  data () {
    return {
      openPopup: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/generic/IconTextIconText.vue